import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { getPreviousDateAccToDays } from "utils/Utils";
import { headerLabel } from "assets/properties/properties";
import { removeUnderscores } from "utils/Utils";
import { useNavigate } from "react-router-dom";
import { forApprovalTableColumns } from "assets/properties/properties";
import { getApplicationFromDate } from "assets/properties/properties";
import useApplicantStatusData from "hooks/useApplicantStatusData";
import ViewDetailsLink from "./SendBackDetails/ViewDetailsLink";
import StageHistoryModal from "./SendBackDetails/StageHistoryModal";
import { parseAndSetFlag } from "utils/Utils";

const ForApproval = ({ seletedBranchCode, featureFlags }) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [fromDate, setFromDate] = useState(getApplicationFromDate());
  const [toDate, setToDate] = useState(new Date());
  const [branchCodeList, setBranchCodeList] = useState([]);
  const [stageHistoryModal, setStageHistoryModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
    const enabledSendBackStageDetails = parseAndSetFlag(
    featureFlags?.enabledSendBackStageDetails
  );
  const handleFromDateChange = (e) => {
    setFromDate(e);
  };
  const handleToDateChange = (e) => {
    setToDate(e);
  };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const {
    data: applicantData,
    error: applicantDataError,
    callInProgress: applicantDataLoading,
  } = useApplicantStatusData({
    status: "SANCTIONED",
    fromDate,
    toDate,
    authToken,
    enabled: branchCodeList.length > 0,
    useMakerEndpoint: false,
  });
  useEffect(() => {
    getAllBranchDetails();
  }, []);
  const getAllBranchDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FIND_ALL_BRANCH,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!result?.data?.error_code) {
      setBranchCodeList(result?.data);
    }
  };
  useEffect(() => {
    if (applicantDataError) {
      toastUpdate("Error", applicantDataError.user_description, true);
    } else if (branchCodeList.length > 0) {
      parseIndicatorData(applicantData, branchCodeList);
    }
  }, [applicantData, applicantDataError, branchCodeList]);

  const parseIndicatorData = (data, branchList) => {
    let reportData = [];
    data = data.sort((a, b) =>
      a.loanApplicationId < b.loanApplicationId ? 1 : -1
    );
     const matchBranchName = (branchCode) => {
    const branch = branchList.find((branch) => branch.code === branchCode);
    return branch ? branch.name : branchCode;
  }
    data &&
      data.forEach((ForApprovalApplication, index) => {
        let row = {
          applicationid: ForApprovalApplication.loanApplicationId,
          created: ForApprovalApplication.createdBy,
          formNumber: ForApprovalApplication.loanApplicationNumber,
          accountNumber: ForApprovalApplication.loanAccountNumber,
          customerid: ForApprovalApplication.customerId,
          customerName: ForApprovalApplication.customerName,
          branchName: matchBranchName(ForApprovalApplication.branchCode),
          mobile: ForApprovalApplication.mobileNumber?.trim(),
          type: `${removeUnderscores(
            ForApprovalApplication?.applicationType
          )} / ${removeUnderscores(
            ForApprovalApplication?.applicationSubType
          )}`,
          totalCollateralValue: ForApprovalApplication?.totalCollateralValue,
          ...(enabledSendBackStageDetails
        ? {
            stageHistory: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {Number(
                  ForApprovalApplication?.applicationStageHistoryCount
                ) > 0 && (
                  <ViewDetailsLink
                    onClick={() => {
                      setSelectedLeadId(
                        ForApprovalApplication?.loanApplicationId
                      );
                      setStageHistoryModal(true);
                    }}
                  />
                )}
              </div>
            ),
          }
        : {}),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  const onClickUpdateData = async (
    loanApplicationId,
    loanApplicationNumber,
    loanAccountNo,
    totalCollateralValue
  ) => {
    const result = await apiHandler({
      url: endpoint.LOAN_STATUS + `?loanApplicationId=${loanApplicationId}`,
      authToken: authToken,
    });
    const prepledgeLoanMap = result?.data?.prepledgeLoanMap || [];
    const prepledgeLoanAccountNumber = result?.data?.prepledgeLoanAccountNumber ? result?.data?.prepledgeLoanAccountNumber : Object.keys(prepledgeLoanMap || {})?.[0];
    const navigationData = {
      loanApplicationId,
      loanAccountNo,
      status: "FORAPPROVAL",
      subStatus: result?.data?.applicationSubType || "",
      prePledgeLoan: prepledgeLoanAccountNumber || "",
      editable: false,
      loanType: result?.data?.applicationType || "",
      totalCollateralValue,
      seletedBranchCode,
      prepledgeLoanMap:prepledgeLoanMap
    };
    navigate(`/fieldAgent/${loanApplicationId}`, { state: navigationData });
  };
  const tableColumns = enabledSendBackStageDetails
    ? [
        ...forApprovalTableColumns,
        { id: "stageHistory", label: "Stage History" },
      ]
    : forApprovalTableColumns;
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={headerLabel?.approval}
          searchCriteria
          handleFromDateChange={handleFromDateChange}
          fromDate={fromDate}
          handleToDateChange={handleToDateChange}
          toDate={toDate}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable
          columns={tableColumns}
          rows={selectedTableData}
          onClickUpdateData={onClickUpdateData}
          flag="approval"
        />
      </Grid>
      <StageHistoryModal
        open={stageHistoryModal}
        onClose={() => {
          setStageHistoryModal(false);
          setSelectedLeadId(null);
        }}
        leadId={selectedLeadId}
        authToken={authToken}
      />
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {(callInProgress || applicantDataLoading) && <CircularProgresss callInProgress />}
    </Grid>
  );
};

ForApproval.propTypes = {
  classes: PropTypes.object,
};

export default ForApproval;
